module.exports = __webpack_public_path__ + "img/20190612140045微信截图_20190612140334.caa23095.png";